@import 'styles/mixins';
@import 'styles/variables';

.blazeNewButton {
  margin: 0 10px;

  @include for-phone-only {
    button {
      height: 48px;
      font-size: 16px;
      border-radius: 10px;
    }
  }

  button {
    border: none;
  }
}

.nav {
  display: flex;
  padding-top: 10px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;

  @include for-phone-only {
    overflow: auto;
  }

  [data-autopilot-system-redesign='on'] & {
    padding-top: 0;
    gap: 20px;
  }
}

.section {
  width: 100%;
}

.sectionNavItemsList {
  [data-autopilot-system-redesign='on'] & {
    margin-top: 0;
  }
}
